<template>
  <div class="cta-container" :class="display">
    <div class="content" :class="display" @mouseover="setHover(true)" @mouseleave="setHover(false)">
      <slot></slot>
    </div>

    <div class="cta-content" @mouseover="setHover(true)" :class="[ display, { show: showCta, hide: hideCta }]">
      <slot name="cta-content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    display: {
      type: String,
      default: "below"
    },
    showOnHover: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    showCta: function() {
      if (!this.show) { return false; }
      return this.showOnHover ? this.hover : true;
    },
    hideCta: function() {
      if (!this.show) { return true; }
      return this.showOnHover ? !this.hover : false;
    }
  },
  methods: {
    setHover: function(val) {
      this.hover = val;
    }
  },
  data: function() {
    return {
      hover: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/packs/application.scss';

.cta-container {
  display: flex;
  position: relative;
  padding: 0 40px 1.25rem;

  &.below {
    flex-direction: column;
    width: 100%;
    justify-content: center;
    align-items: center;
  }
}

.content {
  flex: 1;
  width: 100%;
}

.cta-content {
  &:not(.below) {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &.show {
    display: block;
  }

  &.hide {
    display: none;
  }
}
</style>
